/* eslint-disable callback-return */
/* eslint-disable no-inline-comments */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import i18n from '../locale'

//- App pages (ie. stuff that gets shown in router view)
import Start from '@/pages/Start/Start'
import LoginPage from '@/pages/Start/LoginPage.vue'
import LoginReturn from '@/pages/Start/LoginReturn'

import Notifications from '@/pages/Notifications/Notifications'
import ReleaseNotes from '@/pages/ReleaseNotes/ReleaseNotes'
//- Status pages
import ForbiddenStatus from '@/pages/Status/Forbidden.vue'
import NotFoundStatus from '@/pages/Status/NotFound.vue'
import LoginHash from "@/pages/LoginHash";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //- Things loaded at start
    {
      path: '/loginreturn',
      name: 'LoginReturn',
      component: LoginReturn
    },
    {
      path: '/login-hash/:hash',
      name: 'LoginHash',
      component: LoginHash,
    },
    {
      path: '/release-notes',
      name: 'ReleaseNotes',
      component: ReleaseNotes,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: Notifications,
      props: true,
      meta: {
        requiresAuth: true
      }
    },

    //- Apprentice application
    {
      path: '/application',
      name: 'ApplicationStart',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Application/ApplicationStart'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/application/:id',
      name: 'ApplicationStart',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Application/ApplicationStart'),
      meta: {
        requiresAuth: true
      }
    },

    //- Register new user
    {
      path: '/register',
      name: 'Register',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Registration/Register')
    },

    //- Site-tour
    {
      path: '/guide',
      name: 'Guide',
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Start/Guide'),
      meta: {
        requiresAuth: true
      }
    },
    //- Company application
    {
      path: '/company/:id/applications',
      name: 'CompanyApplications',
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/ReviewApplications'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/create-applications',
      name: 'CreateCompanyApplications',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CreateApplication'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/create-applications/:appid',
      name: 'CreateCompanyApplications',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CreateApplication'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'Start' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/applications/:application_id/review',
      name: 'AdminApplicationStart',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/ReviewApplication'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },

    //- Employment management
    {
      path: '/company/:id/employees',
      name: 'CompanyEmployees',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyEmployees'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    //- temp landing page to redirect
    {
      path: '/company/:id/CompanyRedirect/:routenm',
      name: 'CompanyRedirect',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/RedirectPage'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    //- Employment management
    {
      path: '/company/:id/paused/new',
      name: 'CompanyPausedPerson',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyPausedPerson'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/paused',
      name: 'CompanyPausedPersons',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyPausedPersons'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/exemptions',
      name: 'CompanyExemptions',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyExemptions'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:company_id/exemption/:exemption_id',
      name: 'CompanyExemption',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyExemption'),
      beforeEnter: (to, from, next) => {
        if (!store.getters['currentuser/isCompanyUser']) next({ name: 'ForbiddenStatus' })
        next()
      }
    },
    {
      path: '/company/:company_id/exemption/new',
      name: 'CompanyExemptionNew',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyExemption'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.company_id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:company_id/exemption/new/:employee_id',
      name: 'NewExemptionForExistingPerson',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyExemption'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.company_id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:company_id/exemption-complited',
      name: 'CompanyExemptionThankYou',
      meta: { label: i18n.t('labels.staff'), requiresAuth: true },
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/ExemptionThankYou'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.company_id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/instructors',
      name: 'CompanyInstructors',
      meta: { label: i18n.t('labels.instructors'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyInstructors'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/education-responsible',
      name: 'CompanyYUA',
      meta: { label: i18n.t('labels.yua'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyYUA'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:companyId/distance-orders',
      name: 'CompanyDistanceOrders',
      props: true,
      meta: { label: i18n.t('labels.orders'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyDistanceOrders'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.companyId)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:companyId/distance-orders/:distance_order_id',
      name: 'CompanyDistanceOrder',
      props: true,
      meta: { label: i18n.t('labels.order'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyDistanceOrder'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.companyId)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:companyId/extension-orders/:distance_order_id',
      name: 'CompanyExtensionOrder',
      props: true,
      meta: { label: i18n.t('labels.order'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyExtensionOrder'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.companyId)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/apprentices',
      name: 'CompanyApprentices',
      meta: { label: i18n.t('labels.apprentices'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyApprentices'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/apprentices-overview',
      name: 'CompanyApprenticesOverview',
      meta: {label: i18n.t('labels.apprentices_overview'), requiresAuth: true},
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyApprenticesOverview'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({name: 'ForbiddenStatus'})
        next()
      }
    },
    {
      path: '/instructor/instructions',
      name: 'InstructorInstructions',
      meta: { label: i18n.t('labels.instructor-instruction'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "instructions" */ '@/pages/Company/InstructorInstructions')
    },
    {
      path: '/instructor/:id/apprentices',
      name: 'CompanyInstructorApprentices',
      meta: { label: i18n.t('labels.my-apprentice'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyInstructorApprentices')
    },
    {
      path: '/company/:id/employees/new',
      name: 'CompanyNewEmployee',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyNewEmployee'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/employees/:employee_id',
      name: 'CompanyEmployee',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyEmployee'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/orders',
      name: 'CompanyOrders',
      meta: { label: i18n.t('labels.approve-distance-orders'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyOrders'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
    },
    {
      path: '/company/:id/permissions',
      name: 'CompanyEmployeesPermissions',
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyPermissions'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/permissions/:employee_id',
      name: 'CompanyEmployeePermissions',
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyEmployeePermissions'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/apprentices/:employee_id',
      name: 'CompanyApprentice',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyEmployee'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },

    //- Workplaces
    {
      path: '/company/:id/workplaces/:workplace_id',
      name: 'CompanyWorkplace',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyWorkplace'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/workplaces',
      name: 'CompanyWorkplaces',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyWorkplaces'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/departments',
      name: 'CompanyDepartments',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyDepartments'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/company/:id/department/:departmentId',
      name: 'Department',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Company/CompanyDepartment'),
      beforeEnter: (to, from, next) => {
        const getterFunc = store.getters['currentuser/isCompanyUser']
        if (!getterFunc(to.params.id)) next({ name: 'ForbiddenStatus' })
        next()
      },
      meta: {
        requiresAuth: true
      }
    },

    //- Ebook
    {
      path: '/book/:id',
      name: 'EbookStart',
      props: true,
      meta: { label: i18n.t('labels.e-book'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/EbookStart')
    },
    {
      path: '/book/:id/report-element',
      name: 'EbookReportElement',
      props: true,
      meta: { label: i18n.t('ebook.report-element'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/ReportElementStart')
    },
    {
      path: '/book/:id/education',
      name: 'EbookEducationStart',
      meta: { label: i18n.t('ebook.show-education'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/EducationStart')
    },
    {
      path: '/book/:id/create-overview',
      name: 'EbookReportOverviewStart',
      props: true,
      meta: { label: i18n.t('ebook.report-overview'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/ReportOverviewStart')
    },
    {
      //path: '/ebook/create-report',
      path: '/book/:id/report/:reportId',
      name: 'EbookReportNew',
      props: true,
      meta: { label: i18n.t('ebook.create-new-report'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/ReportStart')
    },
    // Instructor Ebook
    {
      path: '/instructor/ebooks',
      name: 'ApprenticeEbooks',
      meta: { label: i18n.t('ebook.instructor.e-book'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/instructor/EbookStart')
    },
    {
      path: '/instructor/:id/ebooks',
      name: 'InstructorEbooks',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/instructor/EbookStart')
    },
    {
      path: '/instructor/:id/apprentices-report',
      name: 'InstructorApprenticesReports',
      props: true,
      meta: { label: i18n.t('ebook.instructor.apprentices-reports'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/instructor/ApprenticesReports')
    },
    {
      path: '/books/:bookId/report/:reportId/',
      name: 'InstructorApprenticesReport',
      props: true,
      meta: { label: i18n.t('ebook.instructor.apprentices-report'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/instructor/ApprenticesReport')
    },
    {
      path: '/books/:bookId/report/:reportId/details/:reportDetailId',
      name: 'InstructorApprenticesReportDetails',
      props: true,
      meta: { label: i18n.t('ebook.instructor.apprentices-report.details'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/instructor/ReportDetails')
    },
    {
      path: '/instructor/:id/apprentices-courses',
      name: 'InstructorApprenticesCourses',
      props: true,
      meta: { label: i18n.t('ebook.instructor.apprentices-courses'), requiresAuth: true },
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Ebook/instructor/ApprenticesCourses')
    },

    //- Personal info and settings
    {
      path: '/my-address',
      name: 'PersonAddress',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/MyAddress'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/my-settings',
      name: 'PersonSettings',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/MySettings'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/qr-validation/:id',
      name: 'QrValidation',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/QrValidation')
    },
    {
      path: '/my-qualifications',
      name: 'PersonQualifications',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/MyQualifications'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/apprentice-qualifying-time',
      name: 'ApprenticeQualifyingTime',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/QualifyingTime'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/qualifying-time/:id',
      name: 'PersonQualifyingTime',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/QualifyingTime'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/basic-education',
      name: 'PersonBasicEducationTime',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Person/PersonBasicEducationTime/PersonBasicEducationTime'),
      meta: {
        requiresAuth: true
      }
    },
    //- Order cards or tradecertificates
    {
      path: '/order-card/my-start',
      name: 'MyOrderCardStart',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/MyStart'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order-card/start',
      name: 'OrderCardStart',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/Start'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order-card/:id/start',
      name: 'CompanyOrderCardStart',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/Start'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order-card/:personId/types/:reasonId?',
      name: 'CardTypes',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/CardTypes'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order-card-company/:companyId/types/:reasonId?',
      name: 'CardCompanyTypes',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/CardTypes'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/card/:personId/order/:reasonId?',
      name: 'OrderCard',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/OrderCard'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/card-company/:companyId/order/:personId/apprentice/:apprenticenshipId/:reasonId?',
      name: 'OrderCardCompany',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/OrderCard'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/card/thankyou',
      name: 'CardThankYou',
      props: true,
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/OrderCard/ThankYou'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "minasidor" */ '@/pages/Start/Login'),
    },
    //- App startpage
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '*',
      name: 'NotFoundStatus',
      component: NotFoundStatus
    },
    {
      path: '/forbidden',
      name: 'ForbiddenStatus',
      component: ForbiddenStatus
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('app/setLastPath', from)
  //- Convenience method to check that we have a user
  const user = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      return next('/')
    }
    try {
      const userData = JSON.parse(user)
      if (userData.id < 0) {
        return next('/')
      }
      return next()
    } catch (err) {
      console.log('Error getting user info', err)
      return next('/')
    }
  }
  return next()
})

export default router
